import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener, Inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CommunicationService } from './services/communication.service';
import { ConfigService } from './services/config.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  data: string;
  error: any;
  type: any;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent {
  appMode: any = 'rhib';
  activeModel: any = 'rhib';
  testMode: any = '';
  broadcastSubs
  broadcastIframeSubs: any;
  shipCompsCntls = {};
  showDrawerPanel: any = false;
  showSSPanel=false;
  doreset=false;

  loaderData: any = { state: false, process_txt: "Processing...", selectedDemo: "", event: 'showBlockLoading' };
  
  constructor(public dialog: MatDialog, private cdr: ChangeDetectorRef, private communicationServ: CommunicationService, private configService: ConfigService, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon(
      `2d-icon`,
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/2d-icon.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `3d-icon`,
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/3d-icon.svg")
    );
  }

  /* * * * *
  * method for communicate event instance with data to access all components
  * * * * * */
  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }

  broadcastIframeInfo(data: any) {
    this.communicationServ.createIframeInstance(data);
  }

  initIframeMessage() {
    this.broadcastIframeInfo({ iframeConnection: 'slms-connection', event: 'slms-init', data: '', key: "" });
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  loaderState: any = { state: true, process_txt: "Processing...", selectedDemo: '', event: 'showBlockLoading' };
  ngOnInit() {
    this.initIframeMessage();
    this.getQueryParamValues();
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "loader") {
          if (data.event === 'loaderState') {
            console.log("loaderState", data.data);
            if (data.data.event == 'showBlockLoading') {
              this.loaderState = data.data;
            }
          }
        }
        if (data.src === "main") {
          if (data.event === 'changeview') {
            this.appMode = '';
            let view = data['data'];
            if (view) {
              this.testMode = '';
              this.appMode = view;
              console.log("appMode", this.appMode);              
            }
          }
          if (data.event === 'doreset') {
            this.doreset = true;
          }
        }
        if (data.src === "detailtag") {
          
        }
        if (data.src === "sidepanel") {
          if (data.event === 'nmCompMiniAdd') {
          }
          if (data.event === 'toggle-view') {
            let obj = data['data'];
            if (obj) {
              this.appMode = obj;
              this.activeModel = obj;
              this.setShipCompsCntls();
            }
          }
          
          if (data.event === "rhib-controlChange") {
            let obj = data['data'];
            this.onControlChange(obj)
          }
          
        }
      });

    this.broadcastIframeSubs = this.communicationServ.getIframeInstance()
      .subscribe((data: any) => {
       /*  if (data.iframeConnection === "slms-connection") {
          if (data.event === 'Translate') {
            // this.languageSelected = data.data;
          }
          if (data.event === 'loginInfo') {
            this.configService.accountEmail = data.data['accountEmail'];
            this.configService.userId = data.data['userId'];
            this.configService.accessToken = data.data['accessToken'];
            this.configService.refershToken = data.data['refershToken'];
            console.log("navyscs loginInformation ");
          }
        } */
      })
    this.setShipCompsCntls();
    
  }
  ngAfterViewInit() {
    console.log("ngAfterViewInit ")
    this.cdr.detectChanges();
  }
  /* * *
  * get query params key value format
  * * */
  getKeyValueQueryParams(queryParams) {
    let keyvalue = {};
    queryParams.map(query => {
      let params = query.split("=");
      if (params.length > 0) {
        keyvalue[params[0].trim().toLowerCase()] = params[1].trim().toLowerCase();
      }
    })
    return keyvalue;
  }

  compToggle:any;
  animationIDG:any;
  // presetToggle:any=false;
  getQueryParamValues() {
    if (window.location.search) {
      let queryParams = window.location.search.split('?')[1].split('&');
      let keyValue = this.getKeyValueQueryParams(queryParams);
      console.log("keyValue ", keyValue);

      if (keyValue['appmode'] == 'rhib') {
        this.appMode = keyValue['appmode'];
        this.activeModel = keyValue['appmode'];
        this.showDrawerPanel = true;
      
      } else if (keyValue['appmode']) {
        this.appMode = keyValue['appmode'];
      }

      else {
        this.appMode = 'rhib';
        this.activeModel = 'rhib';
        this.showSSPanel = true;
        this.showDrawerPanel = true;
      }
    } else {
      this.appMode = 'rhib';
        this.activeModel = 'rhib';
        this.showSSPanel = true;
        this.showDrawerPanel = true;
    }
    this.setShipCompsCntls();
    this.configService.appMode = this.appMode;
  }

  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  setShipCompsCntls() {
    this.doreset = true;
    let defCompsCntls = {};
    if (this.appMode === 'rhib') {
      defCompsCntls["Components"] = [{ "name": "compass", "id": "compass", "children": [{ "name": "compass", "id": "compass", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "console", "id": "console", "children": [{ "name": "console", "id": "console", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "console_hatch", "id": "console_hatch", "children": [{ "name": "console_hatch", "id": "console_hatch", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "control_board", "id": "control_board", "children": [{ "name": "control_board", "id": "control_board", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "cooling", "id": "cooling", "children": [{ "name": "cooling", "id": "cooling", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "deck", "id": "deck", "children": [{ "name": "deck", "id": "deck", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "engine", "id": "engine", "children": [{ "name": "engine", "id": "engine", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "engine_housing", "id": "engine_housing", "children": [{ "name": "engine_housing", "id": "engine_housing", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "exhaust", "id": "exhaust", "children": [{ "name": "exhaust", "id": "exhaust", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "fire extinguisher port", "id": "fire extinguisher port", "children": [{ "name": "fire extinguisher port", "id": "fire extinguisher port", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "fire extinguisher stbd", "id": "fire extinguisher stbd", "children": [{ "name": "fire extinguisher stbd", "id": "fire extinguisher stbd", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "fwd_stanchion", "id": "fwd_stanchion", "children": [{ "name": "fwd_stanchion", "id": "fwd_stanchion", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "GPS", "id": "GPS", "children": [{ "name": "GPS", "id": "GPS", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "handrail", "id": "handrail", "children": [{ "name": "handrail", "id": "handrail", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "hull", "id": "hull", "children": [{ "name": "hull", "id": "hull", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "seat_cushion", "id": "seat_cushion", "children": [{ "name": "seat_cushion", "id": "seat_cushion", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "speedo_base", "id": "speedo_base", "children": [{ "name": "speedo_base", "id": "speedo_base", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "sponsons", "id": "sponsons", "children": [{ "name": "sponsons", "id": "sponsons", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "steering_wheel", "id": "steering_wheel", "children": [{ "name": "steering_wheel", "id": "steering_wheel", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "stern_drive", "id": "stern_drive", "children": [{ "name": "stern_drive", "id": "stern_drive", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "throttle", "id": "throttle", "children": [{ "name": "throttle", "id": "throttle", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "transfom_clips", "id": "transfom_clips", "children": [{ "name": "transfom_clips", "id": "transfom_clips", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "transom_ports", "id": "transom_ports", "children": [{ "name": "transom_ports", "id": "transom_ports", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }, { "name": "transom_top", "id": "transom_top", "children": [{ "name": "transom_top", "id": "transom_top", "children": [], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }], "opacity": "solid", "visible": true, "focus": false, "selected": true, "color": "#ffbeb4", "isSub": true, "sensors": [], "animateMedia": false, "hastarget": false }]
      this.shipCompsCntls = this.clone(defCompsCntls);
    } 
  }

  onControlChange(data) {
    let key = data.name;
    let state = data.state;
    let event = data.event;
    if (event === 'update-reset-status') {
      this.doreset = state;
    }
  }

  altKey: boolean = false;
  controlPanelState: boolean = false;
  positiontool = false;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardDownEvent(event: KeyboardEvent) {
    this.altKey = event.altKey;
  }
  @HostListener('document:keyup', ['$event'])
  handleKeyboardUpEvent(event: KeyboardEvent) {
    if (event.key) {
      const key = event.key.toString().toLowerCase();
      this.altKey = false;
      if (event.shiftKey && key === 't') {
        this.controlPanelState = true;
      }
      if (((key === 'v') && event.shiftKey === true)) {
        this.positiontool = !this.positiontool;
      } else if (((key === 's') && event.shiftKey === true)) {
      }
    }

  }
    // boatSpeed:any={x:0,z:0};
  rhibSpeed: any = 50;
  onBoatControlChange(e) {
    console.log('onBoatControlChange', e);
    let action = e.action;
    let value = e.value;
    if (action == 'speed') {
      this.rhibSpeed = value / (100);
    }
  }

  /* * *
  * method for openDialog comp
  * * */
  openDialog(e): void {
    let width = '285px';
    let type = 'error';

    if (e == 'chartmodel') {
      type = 'chartmodel';
      width = '750px'
    }
    if (e == 'confirm-popup') {
      type = 'confirm-popup';
    }
    
    const dialogRef = this.dialog.open(PopupComponent, {
      panelClass: 'full-width-dialog',
      width: width,
      data: { value: '', error: e, type: type },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("result",result,e);
        
        

      }
    });
  }
}


@Component({
  selector: 'popup-model',
  templateUrl: 'popup-model.html',
})

export class PopupComponent {
  constructor(
    public dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public communicationServ: CommunicationService) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeClick(): void {
    this.dialogRef.close();
  }
  onDelete() {
    this.broadcastInfo({ src: 'commentScreen', event: 'deleteComment', data: "", sub: null });
    this.closeClick()
  }
  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }
}
